/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { message } from "antd";
import _axios from "axios";
class ApiClient {
    static removeEmptyFields(obj) {
        return Object.entries(obj || {}).reduce((acc, [k, v]) => {
            if (v != null && v !== "")
                acc[k] = v;
            return acc;
        }, {});
    }
    constructor() {
        const baseURL = (typeof window !== "undefined" && window.BASE_URL) ||
            (typeof globalThis.process !== "undefined" &&
                globalThis.process.env.VITE_BASE_URL) ||
            (location.hostname === "localhost" ||
                (location.hostname === "192.168.0.125" && location.port === "3015")
                ? "http://192.168.0.15:8000"
                : "/");
        this.axios = _axios.create({
            timeout: 0,
            headers: { "Content-Type": "application/json" },
            baseURL,
        });
        this.axios.interceptors.request.use((config) => {
            var _a, _b, _c, _d, _e;
            const token = (_b = (_a = JSON.parse(localStorage.getItem("userInfo") || "{}")) === null || _a === void 0 ? void 0 : _a.token) !== null && _b !== void 0 ? _b : "";
            if (token) {
                // 某些情况下 headers 可能为 undefined，确保存在后再写入
                config.headers = (_c = config.headers) !== null && _c !== void 0 ? _c : {};
                config.headers["Admin-Authorization"] = `Bearer ${token}`;
            }
            const params = ApiClient.removeEmptyFields(((_d = config.params) !== null && _d !== void 0 ? _d : {}));
            const data = ApiClient.removeEmptyFields(((_e = config.data) !== null && _e !== void 0 ? _e : {}));
            config.params = params;
            config.data = data;
            return config;
        }, (error) => {
            return Promise.reject(error);
        });
        this.axios.interceptors.response.use((response) => {
            const data = response.data;
            if ((data === null || data === void 0 ? void 0 : data.code) === 401 || (data === null || data === void 0 ? void 0 : data.msg) === "Invalid admin token") {
                message.error("登录已过期，请重新登录！");
                localStorage.removeItem("userInfo");
                if (typeof window !== "undefined" && location.pathname !== "/login") {
                    window.location.href = "/login";
                }
                return Promise.reject(new Error("登录已过期"));
            }
            return response;
        }, (error) => {
            return Promise.reject(ApiClient.handleError(error));
        });
    }
    static handleError(error) {
        var _a;
        const code = error === null || error === void 0 ? void 0 : error.code;
        if (code === "ERR_NETWORK") {
            message.error("网络异常!");
            return new Error("网络异常!");
        }
        const res = error === null || error === void 0 ? void 0 : error.response;
        const data = (_a = res === null || res === void 0 ? void 0 : res.data) !== null && _a !== void 0 ? _a : {};
        const msg = (data === null || data === void 0 ? void 0 : data.msg) || (data === null || data === void 0 ? void 0 : data.message) || "未知错误";
        const status = res === null || res === void 0 ? void 0 : res.status;
        switch (status) {
            case 400:
                message.error(`${msg}!`);
                return new Error(`${msg}!`);
            case 401:
                message.error(`${msg}!`);
                localStorage.removeItem("userInfo");
                if (typeof window !== "undefined" && location.pathname !== "/login") {
                    window.location.href = "/login";
                }
                return new Error(`${msg}!`);
            case 415:
                message.error("传参错误，请检查传参！");
                return new Error("传参错误，请检查传参！");
            default:
                message.error(msg || "未知错误！");
                return new Error(msg || "未知错误！");
        }
    }
    post(url, postData) {
        return this.axios
            .post(url, postData)
            .then((res) => res.data);
    }
    get(url, postData) {
        return this.axios
            .get(url, {
            params: postData,
        })
            .then((res) => res.data);
    }
    put(url, postData) {
        return this.axios
            .put(url, postData)
            .then((res) => res.data);
    }
    delete(url, postData) {
        return this.axios
            .delete(url, {
            data: postData !== null && postData !== void 0 ? postData : {},
        })
            .then((res) => res.data);
    }
}
export default new ApiClient();
